import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
import VueMarkdown from 'vue-markdown';
import { namespace } from 'vuex-class';
const featsModule = namespace('feats');
let CharacterSheetCustomFeats = class CharacterSheetCustomFeats extends Vue {
    constructor() {
        super(...arguments);
        this.isOpen = false;
        this.selected = '';
    }
    get filteredFeats() {
        const combatNames = this.combatFeatures.map(({ name }) => name);
        return this.feats.filter(({ name }) => !combatNames.includes(name)).map(({ name }) => name);
    }
    get selectedFeat() {
        return this.feats.find(({ name }) => name === this.selected);
    }
    addItem() {
        this.$emit('updateCharacter', { customFeats: { [this.numCustomFeats]: this.selected } });
        this.isOpen = false;
    }
};
__decorate([
    Prop(Number)
], CharacterSheetCustomFeats.prototype, "numCustomFeats", void 0);
__decorate([
    Prop(Array)
], CharacterSheetCustomFeats.prototype, "combatFeatures", void 0);
__decorate([
    featsModule.State
], CharacterSheetCustomFeats.prototype, "feats", void 0);
CharacterSheetCustomFeats = __decorate([
    Component({
        components: {
            MyDialog,
            VueMarkdown
        }
    })
], CharacterSheetCustomFeats);
export default CharacterSheetCustomFeats;
